/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SVGIcons } from "cms/icons/svg-icons";

const AddComponentButton = (props) => {

    const { onClick } = props;
    const { t } = useTranslation();

    return (
        <div className='add-component-button'>
            <Stack direction='column' justifyContent='flex-start' mb={1}>
                <Stack direction='row' justifyContent='center' mt={1}>
                    <Button
                        color='accent'
                        onClick={onClick}
                        size='large'
                        startIcon={<SVGIcons.common.Create />}
                        variant='outlined'
                    >
                        {t("Components.addComponent")}
                    </Button>
                </Stack>
            </Stack>
        </div>
    );
};

export { AddComponentButton };
